import styled from "@emotion/native";
import Button from "../../../../components/Button";
import Text from "../../../../components/Text";

export const Main = styled.View({
    flex: 1,
    paddingBottom: 20,
});

export const Cta = styled(Button)({
    marginBottom: 20,
});

// minor adjustment to give multi-select questions a little more room to breathe.
export const ProgressMulti = styled(Text)({
    // marginTop: -40,
    textAlign: "center",
    marginBottom: 17,
});
